<template>
  <div class="color-sample-sidebar">
    <span class="color-sample-checkout-title">{{ trans('sample_order_checkout') }}</span>
    <div id="color-sample-cost">
      <div class="color-sample-cost-row">
        <div class="cell">{{ trans('sample_order_subtotal') }}</div>
        <div class="cell">{{ getSubtotal }}</div>
      </div>
      <div class="color-sample-cost-row">
        <div class="cell">{{ trans('sample_order_optional_cost') }}</div>
        <div class="cell">{{ getOptionalCost }}</div>
      </div>
      <div class="color-sample-cost-row">
        <div class="cell">{{ trans('sample_order_vat') }} ({{ getVatPercent }})</div>
        <div class="cell">{{ getVat }}</div>
      </div>
      <div class="color-sample-cost-row">
        <div class="cell">{{ trans('sample_order_total') }}</div>
        <div class="cell">{{ getTotal }}</div>
      </div>
      <div class="color-sample-cost-row color-order-checkout-container" v-if="currentStep < 3">
        <div id="color-order-checkout" :class="getCheckoutClasses" @click="forward" v-if="false">
          {{ trans('sample_order_proceed_to_checkout') }}
        </div>
        <button  v-else type="button" id="color-order-checkout-v2" :class="'button type-2 w-100 '+getCheckoutClasses" @click="forward">
          {{ trans('sample_order_proceed_to_checkout') }}
        </button>
      </div>
      <div v-if="currentStep === 3">
        <span class="color-sample-checkout-title">{{ trans('sample_order_payment_method') }}</span>
        <div class="color-sample-payment-methods">
          <div v-for="(method,key) in paymentMethods" :key="key">
            <div class="color-sample-payment-method-icon d-inline-block" >
              <i :class="'fa fa-' + method.icon" aria-hidden="true"></i>
            </div>
            <div class="color-sample-payment-method-name d-inline-block ml-3">
              {{ method.name }}
            </div>
            <div class="clearfix payment-method-extra-icons" v-if="method.extraIcons && method.extraIcons.length>0">
              <i v-for="(extraIcon,index) in method.extraIcons" :key="'extra-icon-'+index" :class="'fa fa-lg mr-2 fa-' + extraIcon" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        <div id="color-order-checkout" :class="getCheckoutClasses" @click="pay" v-if="false">
          {{ trans('sample_order_continue_to_payment') }}
        </div>
        <button v-else id="color-order-checkout-v2" :class="'button type-2 w-100 '+getCheckoutClasses" @click="pay">
          {{ trans('sample_order_continue_to_payment') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {translate} from "../service/translation";
export default {
  components : {
  },
  props : {
    getSubtotal : {
      required : true,
      type : String
    },
    getOptionalCost : {
      required : true,
      type : String
    },
    getVat : {
      required : true,
      type : String
    },
    getTotal : {
      required : true,
      type : String
    },
    getCheckoutClasses : {
      required : true,
      type : String
    },
    getVatPercent : {
      required : true,
      type : String
    },
    paymentMethods : {
      required : true,
      type : Array
    },
    currentStep : {
      required : true,
      type : Number
    },
  },
  data() {
    return {
    }
  },
  methods : {
    goBack() {
      this.$emit('back');
    },
    forward() {
      this.$emit('forward');
    },
    pay() {
      this.$emit('pay');
    },
    trans(key){
      return translate(key);
    },
  },
}
</script>
<style>
.color-sample-details-title {
  font-family: "FranklinGothicBookITC";
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  color: #000000;
}
.color-sample-detail {
  font-family: FranklinGothicBookITC;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  color: #000000;
  padding-bottom:0px;
}
.color-order-billing-title {
  display: block;
  width:100%;
  margin-top:20px;
  margin-bottom:10px;
  font-family: "FranklinGothicBookITC";
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
}
.color-order-billing-subtitle {
  display: block;
  width:100%;
  font-family: FranklinGothicBookITC;
  font-style: normal;
  font-weight: normal;
  font-size: 19px;
}
.color-order-back {
  width:100%;
  max-width:456px;
  display:block;
  background:#E4E4E4;
  color:#757575;
  text-align: center;
  margin-top:90px;
  margin-bottom:30px;
  padding:15px !Important;
  text-decoration: none;
  text-transform: uppercase;
  font-family: "FranklinGothicBookITC";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  cursor:pointer;
}
.color-order-basket-title {
  font-family: "FranklinGothicBookITC";
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
}

.color-order-billing-radio-container {
  position:relative;
  cursor: pointer;
}
.color-order-billing-radio {
  position:absolute;
  top:8px;
  cursor: pointer;
}
.payment-method-extra-icons{
  color:#5d5d5d;
}
.sample-order-checkout-back-button.button.type-1{
  background:#E4E4E4;
}
.sample-order-checkout-back-button.button.type-1:hover{
 background:#d4d4d4;
}
</style>